(function () {
    if (!window.matchMedia('(hover: hover)').matches) return;

    const CLOSE_DELAY = 500;

    const items = document.querySelectorAll('.nav-item.dropdown');
    let closeTimer = null;
    let activeItem = null;

    const getDropdown = (item) => {
        const toggle = item.querySelector('.dropdown-toggle');
        return toggle ? bootstrap.Dropdown.getOrCreateInstance(toggle) : null;
    };

    const closeActive = (immediate = false) => {
        if (!activeItem) return;
        const dd = getDropdown(activeItem);
        if (immediate) {
            dd?.hide();
            activeItem = null;
        } else {
            closeTimer = setTimeout(() => {
                dd?.hide();
                activeItem = null;
            }, CLOSE_DELAY);
        }
    };

    items.forEach((item) => {
        const toggle = item.querySelector('.dropdown-toggle');

        // Odeber Bootstrap click trigger — hover zařízení ho nepotřebují
        // Tablet s myší dostane hover, tablet bez myše neprojde matchMedia výše
        if (toggle) {
            toggle.removeAttribute('data-bs-toggle');
            toggle.removeAttribute('data-bs-auto-close');
        }

        item.addEventListener('mouseenter', () => {
            clearTimeout(closeTimer);

            if (activeItem && activeItem !== item) {
                getDropdown(activeItem)?.hide();
            }

            activeItem = item;
            getDropdown(item)?.show();
        });

        item.addEventListener('mouseleave', () => {
            closeActive(false);
        });

        item.querySelector('.dropdown-menu')?.addEventListener('mouseenter', () => {
            clearTimeout(closeTimer);
        });

        item.querySelector('.dropdown-menu')?.addEventListener('mouseleave', () => {
            closeActive(false);
        });
    });
})();